// extracted by mini-css-extract-plugin
export default {"box":"Wishlist_box__uOb4J","textoverflow":"Wishlist_textoverflow__BeaMM","align_middle":"Wishlist_align_middle__vuFYX"};